// extracted by mini-css-extract-plugin
export default {"reportManagement":"ReportManagement_reportManagement__eOk1P","contentTitle":"ReportManagement_contentTitle__JHbUg"};